export const TOP_GAINERS_LOSERS = "TOP_GAINERS_LOSERS";
export const TOP_GAINERS_LOSERS_STREAM = "TOP_GAINERS_LOSERS_STREAM";
export const TOP_GAINERS_LOSER_LAST_TIME_UPDATED = "TOP_GAINERS_LOSER_LAST_TIME_UPDATED";
